<template>
	<div id="Main">
		<setpbox :type="1"></setpbox>
		<div class="content">
			<van-image class="logo" width="33%" fit="contain" :src="require('../../assets/images/service/logo.png')" />
			<div class="inputbox">
				<van-icon class="icon" :name="require('../../assets/images/service/phone.png')" />
				<van-field class="input" type="number" maxlength="11" v-model="phone" placeholder="请输入申请人本人手机号" />
			</div>
			<div class="inputbox">
				<van-icon class="icon" :name="require('../../assets/images/service/code.png')" />
				<van-field class="input" v-model="code" maxlength="6" placeholder="验证码" />
				<span class="countdown" slot="button" v-if="time!=60">{{time}}s</span>
				<span class="button" slot="button" v-else  @click="getcode">
					<van-button class="codebox" round size="small" type="primary">获取验证码</van-button>
				</span>
			</div>
			<van-button round type="info" class="submit" @click="submit">下一步</van-button>
		</div>
	</div>
</template>
<script>
	import setpbox from '../../components/setpbox';
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {
			setpbox
		},
		data() {
			return {
				phone: '',
				code: '',
				time: 60,
				phonedata:'',
				openId:''
			}
		},
		methods: {
			submit() {
				if(this.phone.length!=11){
					this.$toast({duration:4000,message:'请输入正确的手机号！'});
					return false
				}
				if(this.code != this.phonedata){
					this.$toast({duration:4000,message:'验证码不正确！'});
					return false
				}
				this.$router.push({
					path: '/agreement',
					query:{
						phone:this.phone,
						openId:this.openId
					}
				})
			},
			settime() { /* 计时处理 */
				let t = this;
				let clear = setInterval(function() {
					window.console.log(t.time)
					t.time = t.time - 1;
					if (t.time < 0) {
						clearInterval(clear)
						t.time = 60;
					}
				}, 1000)
			},
			getcode() { /* 获取短信验证码 */
				if(this.phone.length!=11){
					this.$toast({duration:4000,message:'请输入正确的手机号！'});
					return false;
				}
				axiosPost.getwxphone({
					phone: this.phone,
				}).then((res) => {
					window.console.log(res)
					if (res.data.code == 200) {
						this.phonedata=res.data.data;
						this.$toast({duration:4000,message:'发送成功！'});
						this.settime();
					} else {
						this.$toast({duration:4000,message:res.data.msg});
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
		},
		mounted() {
			this.openId=this.$route.query.openId
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		display: flex;
		flex-direction: column;
		padding: 0 1.3rem;
		height: 100vh;
	}
	.content {
		flex: 1;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;

		.logo {
			margin-bottom: 3rem;
		}

		.inputbox {
			display: flex;
			margin-bottom: 2rem;
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			border-bottom: 1px solid #ebebeb;

			.icon {
				display: flex;
				justify-content: center;
				flex-direction: column;
			}

			.input {
				flex: 1;
				padding: 0 1rem;
				height: 4rem;
				line-height: 4rem;

				&:not(:last-child):after {
					display: none;
				}
			}

			.countdown {
				line-height: 4rem;
				color: #fa6b6b;
			}

			.button {
				line-height: 4rem;
				font-size: 0;

				.codebox {
					background-color: #d2d2d2;
					border: 0;
					color: #666666;
				}
			}
		}

		.submit {
			width: 70%;
			background-color: #fa6b6b;
			border: 0;
			margin-top: 3rem;
			-moz-user-select:none;
			-webkit-user-select:none;
			user-select:none;  
		}
	}
</style>
